module.exports = __webpack_public_path__ + "img/fi-rr-clip.7f84929c.svg";